
import { MdErrorOutline } from "react-icons/md";

export const renderError = (msg) => {
    if (msg) {
        return <div className='my-2 text-red-500 px-2 py-1 bg-red-50 rounded-lg flex gap-2 items-center'><MdErrorOutline className='flex-shrink-0' /><p className='text-sm'>{msg}</p></div>
    }
    else return null
}